
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {Table, Column, Cell} from 'components/Table'
import Container from 'components/ContainerDimentionsContext'
import MetricChart from './MetricChart'
import partial from 'utils/partial'
import classnames from 'classnames'

export default class MetricTable extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    timePeriod: PropTypes.string,
    data: PropTypes.array,
    isLoading: PropTypes.bool,
    invertAreaColors: PropTypes.bool,
    columns: PropTypes.array
  }

  render() {
    const {className} = this.props
    const classNames = classnames('metric-table', className)

    return (
      <div className={classNames}>
        {this.renderTable()}
      </div>
    )
  }

  renderTable() {
    const {data, isLoading, timePeriod} = this.props

    return (
      <Table
        className='metric-table_table'
        data={data}
        loading={isLoading}
        empty={<Cell>We don{`'`}t have any data for the current {timePeriod} yet.</Cell>}
      >
        <Column
          header='Metric'
          cell={data => (
            <Cell>
              {data.label}
            </Cell>
          )}
          width='12%'
        />
        {this.renderCharts()}
        {this.renderColumns()}
      </Table>
    )
  }

  renderTableHeader(key, label, description) {
    return (
      <Cell>
        <div className='metric-table_table_header'>
          <div className='metric-table_table_header_wrapper'>
            <span className='metric-table_table_header_item'>
              {label}
            </span>
          </div>
          <span className='metric-table_table_header_description'>
            {description}
          </span>
        </div>
      </Cell>
    )
  }

  renderCharts() {
    const {columns} = this.props
    return columns.filter(column => column.type === 'chart').map((column, index, arr) => {
      const {
        label,
        width
      } = column

      return (
        <Column
          key={index}
          header={
            (arr.length === 1)
              ? label
              : <Cell className='metric-table_table_header-chart'>
                <div className='metric-table_table_header-label'>{label}</div>
              </Cell>
          }
          cell={data => this.renderChart(column, data)}
          width={width !== 'grow' ? width : null}
          grow={width === 'grow'}
        />
      )
    })
  }

  renderColumns() {
    const {columns} = this.props
    return columns.filter(column => column.type === 'value').map((column, index) => {
      const {
        headerKey,
        label,
        description,
        width,
        dataKey,
        format,
        applyColor
      } = column

      return (
        <Column
          key={index}
          header={this.renderTableHeader(headerKey, label, description)}
          cell={partial(this.renderCell, dataKey, format, applyColor)}
          width={width}
        />
      )
    })
  }

  renderCell(key, format, applyColor, data) {
    const value = data[key]
    const classNames = classnames('metric-table_table_cell', {
      'is-negative': (value < 0) && applyColor,
      'is-positive': (value > 0) && applyColor,
      'is-huge': (value < 1e5),
      'is-big': (value > 1e5 && value < 1e6),
      'is-normal': (value > 1e6)
    })

    return (
      <Cell className={classNames} format={format}>
        {value || '0'}
      </Cell>
    )
  }

  renderChart(column, data) {
    const {invertAreaColors} = this.props
    const {width, accumulatedValues, format} = column
    const {data: chartData} = data
    const isGrow = width === 'grow'
    const classNames = classnames({
      'metric-table_table_double-chart': !isGrow,
      'metric-table_table_chart': isGrow
    })

    return (
      <Cell className={classNames}>
        <Container className='metric-table_chart'>
          <MetricChart
            data={chartData}
            dataKey={'value'}
            format={format}
            accumulatedValues={accumulatedValues}
            invertAreaColors={invertAreaColors}
          />
        </Container>
      </Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/DataCollectionView/InCommingDataView/MetricTable/index.js